// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html[data-layout='mobile'] .profile-edit-dialog__row {
  max-width: 100%;
  flex-direction: column;
  align-items: stretch;
}

html[data-layout='mobile'] .profile-edit-dialog__row--equal > .profile-edit-dialog__field,
html[data-layout='mobile'] .profile-edit-dialog__row--equal > .profile-edit-dialog__field-type {
  flex: 1 1 auto;
}

html[data-layout='mobile'] .profile-edit-dialog__field-type {
  flex: 1 1 auto;
}

html[data-layout='mobile'] #profile-modal .modal .profile-edit-dialog--heading .profile-edit-dialog__field--dob {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  align-self: stretch;
}

html[data-layout='mobile'] #profile-modal .modal .profile-edit-dialog--heading .profile-edit-dialog__row--heading-dob {
  flex-direction: column;
  align-items: stretch;
}

html[data-layout='mobile'] #profile-modal .modal .profile-edit-dialog--heading .profile-edit-dialog__row--heading-dob > .profile-edit-dialog__field,
html[data-layout='mobile'] #profile-modal .modal .profile-edit-dialog--heading .profile-edit-dialog__row--heading-dob > .profile-edit-dialog__field-type {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  flex: 1 1 auto;
}

html[data-layout='mobile'] #profile-modal .modal .profile-edit-dialog--heading .profile-edit-dialog__input--dob {
  display: block;
  height: var(--min-touch-target, 44px);
  min-height: var(--min-touch-target, 44px);
  max-height: var(--min-touch-target, 44px);
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  line-height: var(--line-height-base, 1.5);
}

html[data-layout='mobile'] #profile-modal .modal .profile-edit-dialog--heading .profile-edit-dialog__input--dob::-webkit-date-and-time-value,
html[data-layout='mobile'] #profile-modal .modal .profile-edit-dialog--heading .profile-edit-dialog__input--dob::-webkit-datetime-edit,
html[data-layout='mobile'] #profile-modal .modal .profile-edit-dialog--heading .profile-edit-dialog__input--dob::-webkit-datetime-edit-fields-wrapper {
  width: 100%;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
  text-align: center;
}

html[data-layout='mobile'] #profile-modal .modal .profile-edit-dialog--heading .profile-edit-dialog__input--dob::-webkit-date-and-time-value {
  text-align: center;
  white-space: nowrap;
}

@media (hover: none) and (pointer: coarse) {
  /* Mobile date inputs can ignore the shared 44px field sizing and let the native picker chrome spill past the dialog field. */
  html[data-layout='mobile'] #profile-modal .modal .profile-edit-dialog--heading .profile-edit-dialog__input--dob {
    height: var(--min-touch-target, 44px);
    min-height: var(--min-touch-target, 44px);
    max-height: var(--min-touch-target, 44px);
    line-height: calc(var(--min-touch-target, 44px) - 2px);
    padding-block: 0;
    width: calc(100% - 1.5rem);
    max-width: calc(100% - 1.5rem);
  }

  html[data-layout='mobile'] #profile-modal .modal .profile-edit-dialog--heading .profile-edit-dialog__input--dob::-webkit-date-and-time-value,
  html[data-layout='mobile'] #profile-modal .modal .profile-edit-dialog--heading .profile-edit-dialog__input--dob::-webkit-datetime-edit,
  html[data-layout='mobile'] #profile-modal .modal .profile-edit-dialog--heading .profile-edit-dialog__input--dob::-webkit-datetime-edit-fields-wrapper {
    line-height: calc(var(--min-touch-target, 44px) - 2px);
  }

  html[data-layout='mobile'] #profile-modal .modal .profile-edit-dialog--heading .profile-edit-dialog__input--dob::-webkit-calendar-picker-indicator {
    margin: 0;
    padding: 0;
  }
}

html[data-layout='mobile'] .profile__edit-form {
  --profile-edit-dialog-mobile-image-button-font-size: var(--font-size-md, 1rem);
  --profile-edit-dialog-mobile-image-label-font-size: var(--font-size-sm, 0.875rem);
  --profile-edit-dialog-mobile-image-description-font-size: 0.625rem;
}

html[data-layout='mobile'] #profile-modal .modal label.profile-edit-dialog__field,
html[data-layout='mobile'] #profile-modal .modal label.profile-edit-dialog__field-type,
html[data-layout='mobile'] #profile-modal .modal .profile-edit-dialog__field > .label,
html[data-layout='mobile'] #profile-modal .modal .profile-edit-dialog__field-type > .label,
html[data-layout='mobile'] #profile-modal .modal .profile-edit-dialog__field-description,
html[data-layout='mobile'] #profile-modal .modal .profile-edit-dialog__entry-heading {
  font-size: var(--font-size-sm, 0.875rem);
  line-height: var(--line-height-base, 1.5);
}

html[data-layout='mobile'] .profile-edit-dialog__section-heading {
  font-size: var(--font-size-lg, 1.125rem);
  line-height: var(--line-height-tight, 1.4);
}

html[data-layout='mobile'] #profile-modal .modal .profile__section-header .profile-edit-dialog__section-heading {
  font-size: var(--font-size-lg, 1.125rem);
  line-height: var(--line-height-tight, 1.4);
}

html[data-layout='mobile'] #profile-modal .modal .profile__section-header .profile__action-button,
html[data-layout='mobile'] #profile-modal .modal .profile__section-header solid-ui-button.profile__action-button::part(button) {
  font-size: var(--font-size-sm, 0.875rem);
  line-height: var(--line-height-base, 1.5);
}

html[data-layout='mobile'] #profile-modal .modal .profile__section-header .profile__add-more-content,
html[data-layout='mobile'] #profile-modal .modal .profile__section-header .profile-section-collapsible__edit-label {
  font-size: var(--font-size-sm, 0.875rem);
}

html[data-layout='mobile'] #profile-modal .modal .profile__section-header .profile__add-more-icon,
html[data-layout='mobile'] #profile-modal .modal .profile__section-header .profile-section-collapsible__edit-icon {
  width: var(--icon-xxs, 1rem);
  height: var(--icon-xxs, 1rem);
  padding: 0.125rem;
  box-sizing: border-box;
}

html[data-layout='mobile'] #profile-modal .modal .profile__section-header .profile__add-more-icon svg,
html[data-layout='mobile'] #profile-modal .modal .profile__section-header .profile-section-collapsible__edit-icon svg {
  width: 100%;
  height: 100%;
}

html[data-layout='mobile'] .profile-edit-dialog__row--inline-end {
  justify-content: flex-start;
}

html[data-layout='mobile'] .profile-edit-dialog__actions {
  justify-content: flex-start;
}

html[data-layout='mobile'] .profile-edit-dialog__textarea {
  min-height: 15rem !important;
}

html[data-layout='mobile'] .profile-edit-dialog__input--with-action {
  padding-right: 6.5rem;
}

html[data-layout='mobile'] .profile-edit-dialog__paste-button {
  right: var(--spacing-xxs, 0.3125rem);
  --button-padding-md: var(--spacing-xxs, 0.3125rem) var(--spacing-xxs, 0.3125rem);
  --button-font-size-md: var(--font-size-2xs, 0.6875rem);
  --button-icon-size-md: var(--font-size-xxs, 0.75rem);
  --button-icon-size-lg: var(--font-size-xxs, 0.75rem);
}

html[data-layout='mobile'] .profile-edit-dialog__field input,
html[data-layout='mobile'] .profile-edit-dialog__field select,
html[data-layout='mobile'] .profile-edit-dialog__field-type input,
html[data-layout='mobile'] .profile-edit-dialog__field-type select,
html[data-layout='mobile'] .profile-edit-dialog__textarea {
  font-size: 1rem; 
}

html[data-layout='mobile'] #profile-modal .modal .profile-edit-dialog__field solid-ui-select,
html[data-layout='mobile'] #profile-modal .modal .profile-edit-dialog__field solid-ui-combobox,
html[data-layout='mobile'] #profile-modal .modal .profile-edit-dialog__field-type solid-ui-select,
html[data-layout='mobile'] #profile-modal .modal .profile-edit-dialog__field-type solid-ui-combobox {
  --font-size-sm: 1rem; 
}

html[data-layout='mobile'] #profile-modal .modal solid-ui-combobox::part(input),
html[data-layout='mobile'] #profile-modal .modal solid-ui-combobox::part(option),
html[data-layout='mobile'] #profile-modal .modal solid-ui-combobox::part(selected-option),
html[data-layout='mobile'] #profile-modal .modal solid-ui-select::part(select-trigger),
html[data-layout='mobile'] #profile-modal .modal solid-ui-select::part(trigger-label),
html[data-layout='mobile'] #profile-modal .modal solid-ui-select::part(option),
html[data-layout='mobile'] #profile-modal .modal solid-ui-select::part(selected-option) {
  font-size: 1rem;
}


html[data-layout='mobile'] .profile-edit-dialog__input-help-text {
  display: none;
}

html[data-layout='mobile'] .profile-edit-dialog__field-type--contact-point {
  flex: 1 1 auto;
  width: 100%;
  max-width: 100%;
}

html[data-layout='mobile'] .profile-edit-dialog--heading .profile-edit-dialog__row--contact-point {
  flex-direction: row;
  align-items: stretch;
}

html[data-layout='mobile'] .profile-edit-dialog--heading .profile-edit-dialog__row--contact-point.profile-edit-dialog__row--equal > .profile-edit-dialog__field-type.profile-edit-dialog__field-type--contact-point {
  flex: 0 0 6.4375rem;
  width: 6.4375rem;
  min-width: 6.4375rem;
  max-width: 6.4375rem;
}

html[data-layout='mobile'] .profile-edit-dialog__row--address-header {
  flex-direction: row;
  align-items: flex-end;
}

html[data-layout='mobile'] .profile-edit-dialog__row--social {
  margin-left: 0;
  gap: var(--spacing-2xs, 0.625rem);
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
}

html[data-layout='mobile'] .profile-edit-dialog__row--social .profile-edit-dialog__social-icon {
  display: none;
}

html[data-layout='mobile'] .profile-edit-dialog__field--social-type {
  flex: 0 0 4.75rem;
  width: 4.75rem;
  max-width: 4.75rem;
}

html[data-layout='mobile'] .profile-edit-dialog__field--social-url {
  flex: 1 1 auto;
  min-width: 0;
}

html[data-layout='mobile'] .profile-edit-dialog__field--resume-location {
  flex: 1 1 100%;
  width: 100%;
  max-width: 100%;
}

html[data-layout='mobile'] .profile-edit-dialog__row--language {
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
  gap: var(--spacing-xxs, 0.3125rem);
  margin-left: calc(-1 * var(--spacing-xxs, 0.3125rem));
}

html[data-layout='mobile'] .profile-edit-dialog__row--language > .profile-edit-dialog__field--language-name {
  flex: 1 1 0;
  min-width: 0;
  margin-left: calc(-1 * var(--spacing-xxs, 0.3125rem));
}

html[data-layout='mobile'] .profile-edit-dialog__actions--language {
  margin-left: 0;
}

html[data-layout='mobile'] .profile-edit-dialog__row--language > .profile-edit-dialog__drag-handle,
html[data-layout='mobile'] .profile-edit-dialog__actions--language > solid-ui-button.profile-edit-dialog__delete-button {
  min-width: var(--min-touch-target, 44px);
  min-height: var(--min-touch-target, 44px);
  --button-height-md: var(--min-touch-target, 44px);
}

html[data-layout='mobile'] .profile-edit-dialog__row--resume-entry-header {
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
  width: 100%;
  max-width: 100%;
}

html[data-layout='mobile'] .profile-edit-dialog__row--resume-entry-header > .profile-edit-dialog__actions--edge {
  margin-left: auto;
}

html[data-layout='mobile'] .profile-edit-dialog__row--skill {
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
  gap: var(--spacing-2xs, 0.625rem);
}

html[data-layout='mobile'] .profile-edit-dialog__row--skill > .profile-edit-dialog__field {
  flex: 1 1 0;
  min-width: 0;
}

html[data-layout='mobile'] .profile-edit-dialog__row--skill > .profile-edit-dialog__actions {
  flex: 0 0 auto;
  margin-left: 0;
}

html[data-layout='mobile'] .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo {
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
  gap: var(--spacing-xs, 0.75rem);
  width: 100%;
  max-width: 100%;
}

html[data-layout='mobile'] .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo > header {
  margin-bottom: 0;
  flex: 0 0 auto;
}

html[data-layout='mobile'] .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile__hero,
html[data-layout='mobile'] .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile__hero-alt {
  width: 5rem;
  height: 5rem;
}

html[data-layout='mobile'] .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile__hero-alt {
  padding: 0;
}

html[data-layout='mobile'] .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile__image-frame--fallback .profile__hero-alt {
  display: flex;
  align-items: center;
  justify-content: center;
}

html[data-layout='mobile'] .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile-edit-dialog__image-camera-button {
  display: inline-flex;
  right: var(--spacing-xxs, 0.3125rem);
  bottom: var(--spacing-xxs, 0.3125rem);
  width: var(--min-touch-target, 44px);
  height: var(--min-touch-target, 44px);
  min-width: var(--min-touch-target, 44px);
  min-height: var(--min-touch-target, 44px);
  --button-height-md: var(--min-touch-target, 44px);
}

html[data-layout='mobile'] .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile-edit-dialog__image-preview {
  flex: 1 1 auto;
  min-width: 0;
  gap: var(--spacing-xxs, 0.3125rem);
  width: 100%;
}

html[data-layout='mobile'] .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile-edit-dialog__image-preview-label {
  font-size: var(--profile-edit-dialog-mobile-image-label-font-size);
  line-height: var(--line-height-tight, 1.25);
}

html[data-layout='mobile'] .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile-edit-dialog__image-preview-description {
  font-size: var(--profile-edit-dialog-mobile-image-description-font-size);
  line-height: var(--line-height-base, 1.4);
}

html[data-layout='mobile'] .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile-edit-dialog__image-preview-actions {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--spacing-xxs, 0.3125rem);
  width: 100%;
  align-items: stretch;
}

html[data-layout='mobile'] .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile-edit-dialog__image-button {
  width: 100%;
  min-width: 0;
}

html[data-layout='mobile'] .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile-edit-dialog__image-button::part(button) {
  min-width: 0;
  width: 100%;
  justify-content: center;
  padding: var(--spacing-xxs, 0.3125rem) var(--spacing-2xs, 0.625rem);
  font-size: var(--profile-edit-dialog-mobile-image-button-font-size);
}

html[data-layout='mobile'] .profile-edit-dialog__row--address-header .profile-edit-dialog__actions {
  justify-content: flex-end;
}

@media (max-width: 576px) {
  .profile-edit-dialog__row {
    max-width: 100%;
    flex-direction: column;
    align-items: stretch;
  }
  .profile__edit-form {
    --profile-edit-dialog-mobile-image-button-font-size: var(--font-size-md, 1rem);
    --profile-edit-dialog-mobile-image-label-font-size: var(--font-size-sm, 0.875rem);
    --profile-edit-dialog-mobile-image-description-font-size: 0.625rem;
  }

  .profile-edit-dialog__section-heading {
    font-size: var(--font-size-lg, 1.125rem);
    line-height: var(--line-height-tight, 1.4);
  }

  #profile-modal .modal .profile__section-header:not(.profile-edit-dialog__contact-section-header) {
    padding: var(--spacing-sm, 0.938rem);
    gap: var(--spacing-lg, 1.5625rem);
  }

  #profile-modal .modal .profile__section-header .profile-edit-dialog__section-heading {
    font-size: var(--font-size-lg, 1.125rem);
    line-height: var(--line-height-tight, 1.4);
  }

  #profile-modal .modal .profile__section-header .profile__action-button,
  #profile-modal .modal .profile__section-header solid-ui-button.profile__action-button::part(button) {
    font-size: var(--font-size-sm, 0.875rem);
    line-height: var(--line-height-base, 1.5);
  }

  #profile-modal .modal .profile__section-header .profile__add-more-content,
  #profile-modal .modal .profile__section-header .profile-section-collapsible__edit-label {
    font-size: var(--font-size-sm, 0.875rem);
  }

  #profile-modal .modal .profile__section-header .profile__add-more-icon,
  #profile-modal .modal .profile__section-header .profile-section-collapsible__edit-icon {
    width: var(--icon-xxs, 1rem);
    height: var(--icon-xxs, 1rem);
    padding: 0.125rem;
    box-sizing: border-box;
  }

  #profile-modal .modal .profile__section-header .profile__add-more-icon svg,
  #profile-modal .modal .profile__section-header .profile-section-collapsible__edit-icon svg {
    width: 100%;
    height: 100%;
  }

  .profile-edit-dialog__row--equal > .profile-edit-dialog__field,
  .profile-edit-dialog__row--equal > .profile-edit-dialog__field-type {
    flex: 1 1 auto;
  }

  .profile-edit-dialog__field-type {
    flex: 1 1 auto;
  }

  .profile-edit-dialog__row--inline-end {
    justify-content: flex-start;
  }

  .profile-edit-dialog__actions {
    justify-content: flex-start;
  }

  .profile-edit-dialog__textarea {
    min-height: 15rem !important;
  }

  .profile-edit-dialog__input--with-action {
    padding-right: 6.5rem;
  }

  .profile-edit-dialog__paste-button {
    right: var(--spacing-xxs, 0.3125rem);
    --button-padding-md: var(--spacing-xxs, 0.3125rem) var(--spacing-xxs, 0.3125rem);
    --button-font-size-md: var(--font-size-2xs, 0.6875rem);
    --button-icon-size-md: var(--font-size-xxs, 0.75rem);
    --button-icon-size-lg: var(--font-size-xxs, 0.75rem);
  }

  .profile-edit-dialog__field input,
  .profile-edit-dialog__field select,
  .profile-edit-dialog__field-type input,
  .profile-edit-dialog__field-type select,
  .profile-edit-dialog__textarea {
    font-size: var(--font-size-sm, 0.875rem);
  }

  #profile-modal .modal .profile-edit-dialog__field solid-ui-select,
  #profile-modal .modal .profile-edit-dialog__field solid-ui-combobox,
  #profile-modal .modal .profile-edit-dialog__field-type solid-ui-select,
  #profile-modal .modal .profile-edit-dialog__field-type solid-ui-combobox {
    --font-size-sm: var(--font-size-sm, 0.875rem);
  }

  #profile-modal .modal solid-ui-combobox::part(input),
  #profile-modal .modal solid-ui-combobox::part(option),
  #profile-modal .modal solid-ui-combobox::part(selected-option),
  #profile-modal .modal solid-ui-select::part(select-trigger),
  #profile-modal .modal solid-ui-select::part(trigger-label),
  #profile-modal .modal solid-ui-select::part(option),
  #profile-modal .modal solid-ui-select::part(selected-option) {
    font-size: var(--font-size-sm, 0.875rem);
  }

  .profile-edit-dialog__input-help-text {
    display: none;
  }

  .profile-edit-dialog__field-type--contact-point {
    flex: 1 1 auto;
    width: 100%;
    max-width: 100%;
  }

  .profile-edit-dialog--heading .profile-edit-dialog__row--contact-point {
    flex-direction: row;
    align-items: stretch;
  }

  .profile-edit-dialog--heading .profile-edit-dialog__row--contact-point.profile-edit-dialog__row--equal > .profile-edit-dialog__field-type.profile-edit-dialog__field-type--contact-point {
    flex: 0 0 6.4375rem;
    width: 6.4375rem;
    min-width: 6.4375rem;
    max-width: 6.4375rem;
  }

  .profile-edit-dialog__row--address-header {
    flex-direction: row;
    align-items: flex-end;
  }

  .profile-edit-dialog__row--social {
    margin-left: 0;
    gap: var(--spacing-2xs, 0.625rem);
    flex-direction: row;
    align-items: center;
    flex-wrap: nowrap;
  }

  .profile-edit-dialog__row--social .profile-edit-dialog__social-icon {
    display: none;
  }

  .profile-edit-dialog__field--social-type {
    flex: 0 0 4.75rem;
    width: 4.75rem;
    max-width: 4.75rem;
  }

  .profile-edit-dialog__field--social-url {
    flex: 1 1 auto;
    min-width: 0;
  }

  .profile-edit-dialog__field--resume-location {
    flex: 1 1 100%;
    width: 100%;
    max-width: 100%;
  }

  .profile-edit-dialog__row--language {
    flex-direction: row;
    align-items: center;
    flex-wrap: nowrap;
    gap: var(--spacing-xxs, 0.3125rem);
    margin-left: calc(-1 * var(--spacing-xxs, 0.3125rem));
  }

  .profile-edit-dialog__row--language > .profile-edit-dialog__field--language-name {
    flex: 1 1 0;
    min-width: 0;
    margin-left: calc(-1 * var(--spacing-xxs, 0.3125rem));
  }

  .profile-edit-dialog__actions--language {
    margin-left: 0;
  }

  .profile-edit-dialog__row--language > solid-ui-button.profile-edit-dialog__drag-handle,
  .profile-edit-dialog__actions--language > solid-ui-button.profile-edit-dialog__delete-button {
    min-width: var(--min-touch-target, 44px);
    min-height: var(--min-touch-target, 44px);
    --button-height-md: var(--min-touch-target, 44px);
  }

  .profile-edit-dialog__row--resume-entry-header {
    flex-direction: row;
    align-items: center;
    flex-wrap: nowrap;
    width: 100%;
    max-width: 100%;
  }

  .profile-edit-dialog__row--resume-entry-header > .profile-edit-dialog__actions--edge {
    margin-left: auto;
  }

  .profile-edit-dialog__row--skill {
    flex-direction: row;
    align-items: center;
    flex-wrap: nowrap;
    gap: var(--spacing-2xs, 0.625rem);
  }

  .profile-edit-dialog__row--skill > .profile-edit-dialog__field {
    flex: 1 1 0;
    min-width: 0;
  }

  .profile-edit-dialog__row--skill > .profile-edit-dialog__actions {
    flex: 0 0 auto;
    margin-left: 0;
  }

  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo {
    flex-direction: row;
    align-items: center;
    flex-wrap: nowrap;
    gap: var(--spacing-xs, 0.75rem);
    width: 100%;
    max-width: 100%;
  }

  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo > header {
    margin-bottom: 0;
    flex: 0 0 auto;
  }

  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile__hero,
  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile__hero-alt {
    width: 5rem;
    height: 5rem;
  }

  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile__hero-alt {
    padding: 0;
  }

  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile__image-frame--fallback .profile__hero-alt {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile-edit-dialog__image-camera-button {
    display: inline-flex;
    right: var(--spacing-xxs, 0.3125rem);
    bottom: var(--spacing-xxs, 0.3125rem);
    width: var(--min-touch-target, 44px);
    height: var(--min-touch-target, 44px);
    min-width: var(--min-touch-target, 44px);
    min-height: var(--min-touch-target, 44px);
    --button-height-md: var(--min-touch-target, 44px);
  }

  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile-edit-dialog__image-preview {
    flex: 1 1 auto;
    min-width: 0;
    gap: var(--spacing-xxs, 0.3125rem);
    width: 100%;
  }

  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile-edit-dialog__image-preview-label {
    font-size: var(--profile-edit-dialog-mobile-image-label-font-size);
    line-height: var(--line-height-tight, 1.25);
  }

  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile-edit-dialog__image-preview-description {
    font-size: var(--profile-edit-dialog-mobile-image-description-font-size);
    line-height: var(--line-height-base, 1.4);
  }

  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile-edit-dialog__image-preview-actions {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: var(--spacing-xs, 0.5rem);
    width: 100%;
    align-items: stretch;
  }

  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile-edit-dialog__image-button {
    width: 100%;
    min-width: 0;
  }

  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile-edit-dialog__image-button::part(button) {
    min-width: 0;
    width: 100%;
    justify-content: center;
    padding: var(--spacing-xxs, 0.3125rem) var(--spacing-2xs, 0.625rem);
    font-size: var(--profile-edit-dialog-mobile-image-button-font-size);
  }

  .profile-edit-dialog__row--address-header .profile-edit-dialog__actions {
    justify-content: flex-end;
  }
}

@container profile-pane (max-width: 576px) {
  .profile-edit-dialog__row {
    max-width: 100%;
    flex-direction: column;
    align-items: stretch;
  }

  .profile__edit-form {
    --profile-edit-dialog-mobile-image-button-font-size: var(--font-size-md, 1rem);
    --profile-edit-dialog-mobile-image-label-font-size: var(--font-size-sm, 0.875rem);
    --profile-edit-dialog-mobile-image-description-font-size: 0.625rem;
  }

  .profile-edit-dialog__section-heading {
    font-size: var(--font-size-lg, 1.125rem);
    line-height: var(--line-height-tight, 1.4);
  }

  #profile-modal .modal .profile__section-header:not(.profile-edit-dialog__contact-section-header) {
    padding: var(--spacing-sm, 0.938rem);
    gap: var(--spacing-lg, 1.5625rem);
  }

  #profile-modal .modal .profile__section-header .profile-edit-dialog__section-heading {
    font-size: var(--font-size-lg, 1.125rem);
    line-height: var(--line-height-tight, 1.4);
  }

  #profile-modal .modal .profile__section-header .profile__action-button,
  #profile-modal .modal .profile__section-header solid-ui-button.profile__action-button::part(button) {
    font-size: var(--font-size-sm, 0.875rem);
    line-height: var(--line-height-base, 1.5);
  }

  #profile-modal .modal .profile__section-header .profile__add-more-content,
  #profile-modal .modal .profile__section-header .profile-section-collapsible__edit-label {
    font-size: var(--font-size-sm, 0.875rem);
  }

  #profile-modal .modal .profile__section-header .profile__add-more-icon,
  #profile-modal .modal .profile__section-header .profile-section-collapsible__edit-icon {
    width: var(--icon-xxs, 1rem);
    height: var(--icon-xxs, 1rem);
    padding: 0.125rem;
    box-sizing: border-box;
  }

  #profile-modal .modal .profile__section-header .profile__add-more-icon svg,
  #profile-modal .modal .profile__section-header .profile-section-collapsible__edit-icon svg {
    width: 100%;
    height: 100%;
  }

  .profile-edit-dialog__row--equal > .profile-edit-dialog__field,
  .profile-edit-dialog__row--equal > .profile-edit-dialog__field-type {
    flex: 1 1 auto;
  }

  .profile-edit-dialog__field-type {
    flex: 1 1 auto;
  }

  .profile-edit-dialog__row--inline-end {
    justify-content: flex-start;
  }

  .profile-edit-dialog__actions {
    justify-content: flex-start;
  }

  .profile-edit-dialog__textarea {
    min-height: 15rem !important;
  }

  .profile-edit-dialog__input--with-action {
    padding-right: 6.5rem;
  }

  .profile-edit-dialog__paste-button {
    right: var(--spacing-xxs, 0.3125rem);
    --button-padding-md: var(--spacing-xxs, 0.3125rem) var(--spacing-xxs, 0.3125rem);
    --button-font-size-md: var(--font-size-2xs, 0.6875rem);
    --button-icon-size-md: var(--font-size-xxs, 0.75rem);
    --button-icon-size-lg: var(--font-size-xxs, 0.75rem);
  }

  .profile-edit-dialog__field input,
  .profile-edit-dialog__field select,
  .profile-edit-dialog__field-type input,
  .profile-edit-dialog__field-type select,
  .profile-edit-dialog__textarea {
    font-size: var(--font-size-sm, 0.875rem);
  }

  #profile-modal .modal .profile-edit-dialog__field solid-ui-select,
  #profile-modal .modal .profile-edit-dialog__field solid-ui-combobox,
  #profile-modal .modal .profile-edit-dialog__field-type solid-ui-select,
  #profile-modal .modal .profile-edit-dialog__field-type solid-ui-combobox {
    --font-size-sm: var(--font-size-sm, 0.875rem);
  }

  #profile-modal .modal solid-ui-combobox::part(input),
  #profile-modal .modal solid-ui-combobox::part(option),
  #profile-modal .modal solid-ui-combobox::part(selected-option),
  #profile-modal .modal solid-ui-select::part(select-trigger),
  #profile-modal .modal solid-ui-select::part(trigger-label),
  #profile-modal .modal solid-ui-select::part(option),
  #profile-modal .modal solid-ui-select::part(selected-option) {
    font-size: var(--font-size-sm, 0.875rem);
  }

  .profile-edit-dialog__input-help-text {
    display: none;
  }

  .profile-edit-dialog__field-type--contact-point {
    flex: 1 1 auto;
    width: 100%;
    max-width: 100%;
  }

  .profile-edit-dialog--heading .profile-edit-dialog__row--contact-point {
    flex-direction: row;
    align-items: stretch;
  }

  .profile-edit-dialog--heading .profile-edit-dialog__row--contact-point.profile-edit-dialog__row--equal > .profile-edit-dialog__field-type.profile-edit-dialog__field-type--contact-point {
    flex: 0 0 6.4375rem;
    width: 6.4375rem;
    min-width: 6.4375rem;
    max-width: 6.4375rem;
  }

  .profile-edit-dialog__row--address-header {
    flex-direction: row;
    align-items: flex-end;
  }

  .profile-edit-dialog__row--social {
    margin-left: 0;
    gap: var(--spacing-2xs, 0.625rem);
    flex-direction: row;
    align-items: center;
    flex-wrap: nowrap;
  }

  .profile-edit-dialog__row--social .profile-edit-dialog__social-icon {
    display: none;
  }

  .profile-edit-dialog__field--social-type {
    flex: 0 0 4.75rem;
    width: 4.75rem;
    max-width: 4.75rem;
  }

  .profile-edit-dialog__field--social-url {
    flex: 1 1 auto;
    min-width: 0;
  }

  .profile-edit-dialog__field--resume-location {
    flex: 1 1 100%;
    width: 100%;
    max-width: 100%;
  }

  .profile-edit-dialog__row--language {
    flex-direction: row;
    align-items: center;
    flex-wrap: nowrap;
    gap: var(--spacing-xxs, 0.3125rem);
    margin-left: calc(-1 * var(--spacing-xxs, 0.3125rem));
  }

  .profile-edit-dialog__row--language > .profile-edit-dialog__field--language-name {
    flex: 1 1 0;
    min-width: 0;
    margin-left: calc(-1 * var(--spacing-xxs, 0.3125rem));
  }

  .profile-edit-dialog__actions--language {
    margin-left: 0;
  }

  .profile-edit-dialog__row--language > solid-ui-button.profile-edit-dialog__drag-handle,
  .profile-edit-dialog__actions--language > solid-ui-button.profile-edit-dialog__delete-button {
    min-width: var(--min-touch-target, 44px);
    min-height: var(--min-touch-target, 44px);
    --button-height-md: var(--min-touch-target, 44px);
  }

  .profile-edit-dialog__row--resume-entry-header {
    flex-direction: row;
    align-items: center;
    flex-wrap: nowrap;
    width: 100%;
    max-width: 100%;
  }

  .profile-edit-dialog__row--resume-entry-header > .profile-edit-dialog__actions--edge {
    margin-left: auto;
  }

  .profile-edit-dialog__row--skill {
    flex-direction: row;
    align-items: center;
    flex-wrap: nowrap;
    gap: var(--spacing-2xs, 0.625rem);
  }

  .profile-edit-dialog__row--skill > .profile-edit-dialog__field {
    flex: 1 1 0;
    min-width: 0;
  }

  .profile-edit-dialog__row--skill > .profile-edit-dialog__actions {
    flex: 0 0 auto;
    margin-left: 0;
  }

  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile__hero,
  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile__hero-alt {
    width: 5rem;
    height: 5rem;
  }

  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo {
    flex-direction: row;
    align-items: center;
    flex-wrap: nowrap;
    gap: var(--spacing-xs, 0.75rem);
    width: 100%;
    max-width: 100%;
  }

  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo > header {
    margin-bottom: 0;
    flex: 0 0 auto;
  }

  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile__hero-alt {
    padding: 0;
  }

  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile__image-frame--fallback .profile__hero-alt {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile-edit-dialog__image-camera-button {
    display: inline-flex;
    right: var(--spacing-xxs, 0.3125rem);
    bottom: var(--spacing-xxs, 0.3125rem);
    width: var(--min-touch-target, 44px);
    height: var(--min-touch-target, 44px);
    min-width: var(--min-touch-target, 44px);
    min-height: var(--min-touch-target, 44px);
    --button-height-md: var(--min-touch-target, 44px);
  }

  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile-edit-dialog__image-preview {
    flex: 1 1 auto;
    min-width: 0;
    gap: var(--spacing-xxs, 0.3125rem);
    width: 100%;
  }

  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile-edit-dialog__image-preview-label {
    font-size: var(--profile-edit-dialog-mobile-image-label-font-size);
    line-height: var(--line-height-tight, 1.25);
  }

  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile-edit-dialog__image-preview-description {
    font-size: var(--profile-edit-dialog-mobile-image-description-font-size);
    line-height: var(--line-height-base, 1.4);
  }

  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile-edit-dialog__image-preview-actions {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: var(--spacing-xs, 0.5rem);
    width: 100%;
    align-items: stretch;
  }

  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile-edit-dialog__image-button {
    width: 100%;
    min-width: 0;
  }

  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile-edit-dialog__image-button::part(button) {
    min-width: 0;
    width: 100%;
    justify-content: center;
    padding: var(--spacing-xxs, 0.3125rem) var(--spacing-2xs, 0.625rem);
    font-size: var(--profile-edit-dialog-mobile-image-button-font-size);
  }

  .profile-edit-dialog__row--address-header .profile-edit-dialog__actions {
    justify-content: flex-end;
  }
}
`, "",{"version":3,"sources":["webpack://./node_modules/profile-pane/lib/styles/EditDialogs.responsive.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC,yCAAyC;EACzC,yCAAyC;EACzC,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,6HAA6H;EAC7H;IACE,qCAAqC;IACrC,yCAAyC;IACzC,yCAAyC;IACzC,sDAAsD;IACtD,gBAAgB;IAChB,0BAA0B;IAC1B,8BAA8B;EAChC;;EAEA;;;IAGE,sDAAsD;EACxD;;EAEA;IACE,SAAS;IACT,UAAU;EACZ;AACF;;AAEA;EACE,8EAA8E;EAC9E,iFAAiF;EACjF,kEAAkE;AACpE;;AAEA;;;;;;EAME,wCAAwC;EACxC,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;EACxC,0CAA0C;AAC5C;;AAEA;EACE,wCAAwC;EACxC,0CAA0C;AAC5C;;AAEA;;EAEE,wCAAwC;EACxC,yCAAyC;AAC3C;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA;;EAEE,4BAA4B;EAC5B,6BAA6B;EAC7B,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,gFAAgF;EAChF,sDAAsD;EACtD,oDAAoD;EACpD,oDAAoD;AACtD;;AAEA;;;;;EAKE,eAAe;AACjB;;AAEA;;;;EAIE,oBAAoB;AACtB;;AAEA;;;;;;;EAOE,eAAe;AACjB;;;AAGA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,kCAAkC;EAClC,qDAAqD;AACvD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qDAAqD;AACvD;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,wCAAwC;EACxC,yCAAyC;EACzC,iDAAiD;AACnD;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,+BAA+B;EAC/B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,oCAAoC;EACpC,qCAAqC;EACrC,oCAAoC;EACpC,qCAAqC;EACrC,wCAAwC;EACxC,yCAAyC;EACzC,iDAAiD;AACnD;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,kEAAkE;EAClE,2CAA2C;AAC7C;;AAEA;EACE,wEAAwE;EACxE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,kCAAkC;EAClC,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,mEAAmE;EACnE,mEAAmE;AACrE;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,eAAe;IACf,sBAAsB;IACtB,oBAAoB;EACtB;EACA;IACE,8EAA8E;IAC9E,iFAAiF;IACjF,kEAAkE;EACpE;;EAEA;IACE,wCAAwC;IACxC,0CAA0C;EAC5C;;EAEA;IACE,oCAAoC;IACpC,iCAAiC;EACnC;;EAEA;IACE,wCAAwC;IACxC,0CAA0C;EAC5C;;EAEA;;IAEE,wCAAwC;IACxC,yCAAyC;EAC3C;;EAEA;;IAEE,wCAAwC;EAC1C;;EAEA;;IAEE,4BAA4B;IAC5B,6BAA6B;IAC7B,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,oCAAoC;IACpC,gFAAgF;IAChF,sDAAsD;IACtD,oDAAoD;IACpD,oDAAoD;EACtD;;EAEA;;;;;IAKE,wCAAwC;EAC1C;;EAEA;;;;IAIE,6CAA6C;EAC/C;;EAEA;;;;;;;IAOE,wCAAwC;EAC1C;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,iCAAiC;IACjC,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,YAAY;EACd;;EAEA;IACE,cAAc;IACd,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,kCAAkC;IAClC,qDAAqD;EACvD;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,qDAAqD;EACvD;;EAEA;IACE,cAAc;EAChB;;EAEA;;IAEE,wCAAwC;IACxC,yCAAyC;IACzC,iDAAiD;EACnD;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,iCAAiC;EACnC;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,+BAA+B;IAC/B,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,oBAAoB;IACpB,oCAAoC;IACpC,qCAAqC;IACrC,oCAAoC;IACpC,qCAAqC;IACrC,wCAAwC;IACxC,yCAAyC;IACzC,iDAAiD;EACnD;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,kCAAkC;IAClC,WAAW;EACb;;EAEA;IACE,kEAAkE;IAClE,2CAA2C;EAC7C;;EAEA;IACE,wEAAwE;IACxE,yCAAyC;EAC3C;;EAEA;IACE,aAAa;IACb,gDAAgD;IAChD,8BAA8B;IAC9B,WAAW;IACX,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,uBAAuB;IACvB,mEAAmE;IACnE,mEAAmE;EACrE;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,eAAe;IACf,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,8EAA8E;IAC9E,iFAAiF;IACjF,kEAAkE;EACpE;;EAEA;IACE,wCAAwC;IACxC,0CAA0C;EAC5C;;EAEA;IACE,oCAAoC;IACpC,iCAAiC;EACnC;;EAEA;IACE,wCAAwC;IACxC,0CAA0C;EAC5C;;EAEA;;IAEE,wCAAwC;IACxC,yCAAyC;EAC3C;;EAEA;;IAEE,wCAAwC;EAC1C;;EAEA;;IAEE,4BAA4B;IAC5B,6BAA6B;IAC7B,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,oCAAoC;IACpC,gFAAgF;IAChF,sDAAsD;IACtD,oDAAoD;IACpD,oDAAoD;EACtD;;EAEA;;;;;IAKE,wCAAwC;EAC1C;;EAEA;;;;IAIE,6CAA6C;EAC/C;;EAEA;;;;;;;IAOE,wCAAwC;EAC1C;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,iCAAiC;IACjC,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,YAAY;EACd;;EAEA;IACE,cAAc;IACd,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,kCAAkC;IAClC,qDAAqD;EACvD;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,qDAAqD;EACvD;;EAEA;IACE,cAAc;EAChB;;EAEA;;IAEE,wCAAwC;IACxC,yCAAyC;IACzC,iDAAiD;EACnD;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,iCAAiC;EACnC;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,cAAc;IACd,cAAc;EAChB;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,+BAA+B;IAC/B,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,oBAAoB;IACpB,oCAAoC;IACpC,qCAAqC;IACrC,oCAAoC;IACpC,qCAAqC;IACrC,wCAAwC;IACxC,yCAAyC;IACzC,iDAAiD;EACnD;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,kCAAkC;IAClC,WAAW;EACb;;EAEA;IACE,kEAAkE;IAClE,2CAA2C;EAC7C;;EAEA;IACE,wEAAwE;IACxE,yCAAyC;EAC3C;;EAEA;IACE,aAAa;IACb,gDAAgD;IAChD,8BAA8B;IAC9B,WAAW;IACX,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,uBAAuB;IACvB,mEAAmE;IACnE,mEAAmE;EACrE;;EAEA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["html[data-layout='mobile'] .profile-edit-dialog__row {\n  max-width: 100%;\n  flex-direction: column;\n  align-items: stretch;\n}\n\nhtml[data-layout='mobile'] .profile-edit-dialog__row--equal > .profile-edit-dialog__field,\nhtml[data-layout='mobile'] .profile-edit-dialog__row--equal > .profile-edit-dialog__field-type {\n  flex: 1 1 auto;\n}\n\nhtml[data-layout='mobile'] .profile-edit-dialog__field-type {\n  flex: 1 1 auto;\n}\n\nhtml[data-layout='mobile'] #profile-modal .modal .profile-edit-dialog--heading .profile-edit-dialog__field--dob {\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  overflow: hidden;\n  align-self: stretch;\n}\n\nhtml[data-layout='mobile'] #profile-modal .modal .profile-edit-dialog--heading .profile-edit-dialog__row--heading-dob {\n  flex-direction: column;\n  align-items: stretch;\n}\n\nhtml[data-layout='mobile'] #profile-modal .modal .profile-edit-dialog--heading .profile-edit-dialog__row--heading-dob > .profile-edit-dialog__field,\nhtml[data-layout='mobile'] #profile-modal .modal .profile-edit-dialog--heading .profile-edit-dialog__row--heading-dob > .profile-edit-dialog__field-type {\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  flex: 1 1 auto;\n}\n\nhtml[data-layout='mobile'] #profile-modal .modal .profile-edit-dialog--heading .profile-edit-dialog__input--dob {\n  display: block;\n  height: var(--min-touch-target, 44px);\n  min-height: var(--min-touch-target, 44px);\n  max-height: var(--min-touch-target, 44px);\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  line-height: var(--line-height-base, 1.5);\n}\n\nhtml[data-layout='mobile'] #profile-modal .modal .profile-edit-dialog--heading .profile-edit-dialog__input--dob::-webkit-date-and-time-value,\nhtml[data-layout='mobile'] #profile-modal .modal .profile-edit-dialog--heading .profile-edit-dialog__input--dob::-webkit-datetime-edit,\nhtml[data-layout='mobile'] #profile-modal .modal .profile-edit-dialog--heading .profile-edit-dialog__input--dob::-webkit-datetime-edit-fields-wrapper {\n  width: 100%;\n  min-width: 0;\n  max-width: 100%;\n  overflow: hidden;\n  text-align: center;\n}\n\nhtml[data-layout='mobile'] #profile-modal .modal .profile-edit-dialog--heading .profile-edit-dialog__input--dob::-webkit-date-and-time-value {\n  text-align: center;\n  white-space: nowrap;\n}\n\n@media (hover: none) and (pointer: coarse) {\n  /* Mobile date inputs can ignore the shared 44px field sizing and let the native picker chrome spill past the dialog field. */\n  html[data-layout='mobile'] #profile-modal .modal .profile-edit-dialog--heading .profile-edit-dialog__input--dob {\n    height: var(--min-touch-target, 44px);\n    min-height: var(--min-touch-target, 44px);\n    max-height: var(--min-touch-target, 44px);\n    line-height: calc(var(--min-touch-target, 44px) - 2px);\n    padding-block: 0;\n    width: calc(100% - 1.5rem);\n    max-width: calc(100% - 1.5rem);\n  }\n\n  html[data-layout='mobile'] #profile-modal .modal .profile-edit-dialog--heading .profile-edit-dialog__input--dob::-webkit-date-and-time-value,\n  html[data-layout='mobile'] #profile-modal .modal .profile-edit-dialog--heading .profile-edit-dialog__input--dob::-webkit-datetime-edit,\n  html[data-layout='mobile'] #profile-modal .modal .profile-edit-dialog--heading .profile-edit-dialog__input--dob::-webkit-datetime-edit-fields-wrapper {\n    line-height: calc(var(--min-touch-target, 44px) - 2px);\n  }\n\n  html[data-layout='mobile'] #profile-modal .modal .profile-edit-dialog--heading .profile-edit-dialog__input--dob::-webkit-calendar-picker-indicator {\n    margin: 0;\n    padding: 0;\n  }\n}\n\nhtml[data-layout='mobile'] .profile__edit-form {\n  --profile-edit-dialog-mobile-image-button-font-size: var(--font-size-md, 1rem);\n  --profile-edit-dialog-mobile-image-label-font-size: var(--font-size-sm, 0.875rem);\n  --profile-edit-dialog-mobile-image-description-font-size: 0.625rem;\n}\n\nhtml[data-layout='mobile'] #profile-modal .modal label.profile-edit-dialog__field,\nhtml[data-layout='mobile'] #profile-modal .modal label.profile-edit-dialog__field-type,\nhtml[data-layout='mobile'] #profile-modal .modal .profile-edit-dialog__field > .label,\nhtml[data-layout='mobile'] #profile-modal .modal .profile-edit-dialog__field-type > .label,\nhtml[data-layout='mobile'] #profile-modal .modal .profile-edit-dialog__field-description,\nhtml[data-layout='mobile'] #profile-modal .modal .profile-edit-dialog__entry-heading {\n  font-size: var(--font-size-sm, 0.875rem);\n  line-height: var(--line-height-base, 1.5);\n}\n\nhtml[data-layout='mobile'] .profile-edit-dialog__section-heading {\n  font-size: var(--font-size-lg, 1.125rem);\n  line-height: var(--line-height-tight, 1.4);\n}\n\nhtml[data-layout='mobile'] #profile-modal .modal .profile__section-header .profile-edit-dialog__section-heading {\n  font-size: var(--font-size-lg, 1.125rem);\n  line-height: var(--line-height-tight, 1.4);\n}\n\nhtml[data-layout='mobile'] #profile-modal .modal .profile__section-header .profile__action-button,\nhtml[data-layout='mobile'] #profile-modal .modal .profile__section-header solid-ui-button.profile__action-button::part(button) {\n  font-size: var(--font-size-sm, 0.875rem);\n  line-height: var(--line-height-base, 1.5);\n}\n\nhtml[data-layout='mobile'] #profile-modal .modal .profile__section-header .profile__add-more-content,\nhtml[data-layout='mobile'] #profile-modal .modal .profile__section-header .profile-section-collapsible__edit-label {\n  font-size: var(--font-size-sm, 0.875rem);\n}\n\nhtml[data-layout='mobile'] #profile-modal .modal .profile__section-header .profile__add-more-icon,\nhtml[data-layout='mobile'] #profile-modal .modal .profile__section-header .profile-section-collapsible__edit-icon {\n  width: var(--icon-xxs, 1rem);\n  height: var(--icon-xxs, 1rem);\n  padding: 0.125rem;\n  box-sizing: border-box;\n}\n\nhtml[data-layout='mobile'] #profile-modal .modal .profile__section-header .profile__add-more-icon svg,\nhtml[data-layout='mobile'] #profile-modal .modal .profile__section-header .profile-section-collapsible__edit-icon svg {\n  width: 100%;\n  height: 100%;\n}\n\nhtml[data-layout='mobile'] .profile-edit-dialog__row--inline-end {\n  justify-content: flex-start;\n}\n\nhtml[data-layout='mobile'] .profile-edit-dialog__actions {\n  justify-content: flex-start;\n}\n\nhtml[data-layout='mobile'] .profile-edit-dialog__textarea {\n  min-height: 15rem !important;\n}\n\nhtml[data-layout='mobile'] .profile-edit-dialog__input--with-action {\n  padding-right: 6.5rem;\n}\n\nhtml[data-layout='mobile'] .profile-edit-dialog__paste-button {\n  right: var(--spacing-xxs, 0.3125rem);\n  --button-padding-md: var(--spacing-xxs, 0.3125rem) var(--spacing-xxs, 0.3125rem);\n  --button-font-size-md: var(--font-size-2xs, 0.6875rem);\n  --button-icon-size-md: var(--font-size-xxs, 0.75rem);\n  --button-icon-size-lg: var(--font-size-xxs, 0.75rem);\n}\n\nhtml[data-layout='mobile'] .profile-edit-dialog__field input,\nhtml[data-layout='mobile'] .profile-edit-dialog__field select,\nhtml[data-layout='mobile'] .profile-edit-dialog__field-type input,\nhtml[data-layout='mobile'] .profile-edit-dialog__field-type select,\nhtml[data-layout='mobile'] .profile-edit-dialog__textarea {\n  font-size: 1rem; \n}\n\nhtml[data-layout='mobile'] #profile-modal .modal .profile-edit-dialog__field solid-ui-select,\nhtml[data-layout='mobile'] #profile-modal .modal .profile-edit-dialog__field solid-ui-combobox,\nhtml[data-layout='mobile'] #profile-modal .modal .profile-edit-dialog__field-type solid-ui-select,\nhtml[data-layout='mobile'] #profile-modal .modal .profile-edit-dialog__field-type solid-ui-combobox {\n  --font-size-sm: 1rem; \n}\n\nhtml[data-layout='mobile'] #profile-modal .modal solid-ui-combobox::part(input),\nhtml[data-layout='mobile'] #profile-modal .modal solid-ui-combobox::part(option),\nhtml[data-layout='mobile'] #profile-modal .modal solid-ui-combobox::part(selected-option),\nhtml[data-layout='mobile'] #profile-modal .modal solid-ui-select::part(select-trigger),\nhtml[data-layout='mobile'] #profile-modal .modal solid-ui-select::part(trigger-label),\nhtml[data-layout='mobile'] #profile-modal .modal solid-ui-select::part(option),\nhtml[data-layout='mobile'] #profile-modal .modal solid-ui-select::part(selected-option) {\n  font-size: 1rem;\n}\n\n\nhtml[data-layout='mobile'] .profile-edit-dialog__input-help-text {\n  display: none;\n}\n\nhtml[data-layout='mobile'] .profile-edit-dialog__field-type--contact-point {\n  flex: 1 1 auto;\n  width: 100%;\n  max-width: 100%;\n}\n\nhtml[data-layout='mobile'] .profile-edit-dialog--heading .profile-edit-dialog__row--contact-point {\n  flex-direction: row;\n  align-items: stretch;\n}\n\nhtml[data-layout='mobile'] .profile-edit-dialog--heading .profile-edit-dialog__row--contact-point.profile-edit-dialog__row--equal > .profile-edit-dialog__field-type.profile-edit-dialog__field-type--contact-point {\n  flex: 0 0 6.4375rem;\n  width: 6.4375rem;\n  min-width: 6.4375rem;\n  max-width: 6.4375rem;\n}\n\nhtml[data-layout='mobile'] .profile-edit-dialog__row--address-header {\n  flex-direction: row;\n  align-items: flex-end;\n}\n\nhtml[data-layout='mobile'] .profile-edit-dialog__row--social {\n  margin-left: 0;\n  gap: var(--spacing-2xs, 0.625rem);\n  flex-direction: row;\n  align-items: center;\n  flex-wrap: nowrap;\n}\n\nhtml[data-layout='mobile'] .profile-edit-dialog__row--social .profile-edit-dialog__social-icon {\n  display: none;\n}\n\nhtml[data-layout='mobile'] .profile-edit-dialog__field--social-type {\n  flex: 0 0 4.75rem;\n  width: 4.75rem;\n  max-width: 4.75rem;\n}\n\nhtml[data-layout='mobile'] .profile-edit-dialog__field--social-url {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\nhtml[data-layout='mobile'] .profile-edit-dialog__field--resume-location {\n  flex: 1 1 100%;\n  width: 100%;\n  max-width: 100%;\n}\n\nhtml[data-layout='mobile'] .profile-edit-dialog__row--language {\n  flex-direction: row;\n  align-items: center;\n  flex-wrap: nowrap;\n  gap: var(--spacing-xxs, 0.3125rem);\n  margin-left: calc(-1 * var(--spacing-xxs, 0.3125rem));\n}\n\nhtml[data-layout='mobile'] .profile-edit-dialog__row--language > .profile-edit-dialog__field--language-name {\n  flex: 1 1 0;\n  min-width: 0;\n  margin-left: calc(-1 * var(--spacing-xxs, 0.3125rem));\n}\n\nhtml[data-layout='mobile'] .profile-edit-dialog__actions--language {\n  margin-left: 0;\n}\n\nhtml[data-layout='mobile'] .profile-edit-dialog__row--language > .profile-edit-dialog__drag-handle,\nhtml[data-layout='mobile'] .profile-edit-dialog__actions--language > solid-ui-button.profile-edit-dialog__delete-button {\n  min-width: var(--min-touch-target, 44px);\n  min-height: var(--min-touch-target, 44px);\n  --button-height-md: var(--min-touch-target, 44px);\n}\n\nhtml[data-layout='mobile'] .profile-edit-dialog__row--resume-entry-header {\n  flex-direction: row;\n  align-items: center;\n  flex-wrap: nowrap;\n  width: 100%;\n  max-width: 100%;\n}\n\nhtml[data-layout='mobile'] .profile-edit-dialog__row--resume-entry-header > .profile-edit-dialog__actions--edge {\n  margin-left: auto;\n}\n\nhtml[data-layout='mobile'] .profile-edit-dialog__row--skill {\n  flex-direction: row;\n  align-items: center;\n  flex-wrap: nowrap;\n  gap: var(--spacing-2xs, 0.625rem);\n}\n\nhtml[data-layout='mobile'] .profile-edit-dialog__row--skill > .profile-edit-dialog__field {\n  flex: 1 1 0;\n  min-width: 0;\n}\n\nhtml[data-layout='mobile'] .profile-edit-dialog__row--skill > .profile-edit-dialog__actions {\n  flex: 0 0 auto;\n  margin-left: 0;\n}\n\nhtml[data-layout='mobile'] .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo {\n  flex-direction: row;\n  align-items: center;\n  flex-wrap: nowrap;\n  gap: var(--spacing-xs, 0.75rem);\n  width: 100%;\n  max-width: 100%;\n}\n\nhtml[data-layout='mobile'] .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo > header {\n  margin-bottom: 0;\n  flex: 0 0 auto;\n}\n\nhtml[data-layout='mobile'] .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile__hero,\nhtml[data-layout='mobile'] .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile__hero-alt {\n  width: 5rem;\n  height: 5rem;\n}\n\nhtml[data-layout='mobile'] .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile__hero-alt {\n  padding: 0;\n}\n\nhtml[data-layout='mobile'] .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile__image-frame--fallback .profile__hero-alt {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\nhtml[data-layout='mobile'] .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile-edit-dialog__image-camera-button {\n  display: inline-flex;\n  right: var(--spacing-xxs, 0.3125rem);\n  bottom: var(--spacing-xxs, 0.3125rem);\n  width: var(--min-touch-target, 44px);\n  height: var(--min-touch-target, 44px);\n  min-width: var(--min-touch-target, 44px);\n  min-height: var(--min-touch-target, 44px);\n  --button-height-md: var(--min-touch-target, 44px);\n}\n\nhtml[data-layout='mobile'] .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile-edit-dialog__image-preview {\n  flex: 1 1 auto;\n  min-width: 0;\n  gap: var(--spacing-xxs, 0.3125rem);\n  width: 100%;\n}\n\nhtml[data-layout='mobile'] .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile-edit-dialog__image-preview-label {\n  font-size: var(--profile-edit-dialog-mobile-image-label-font-size);\n  line-height: var(--line-height-tight, 1.25);\n}\n\nhtml[data-layout='mobile'] .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile-edit-dialog__image-preview-description {\n  font-size: var(--profile-edit-dialog-mobile-image-description-font-size);\n  line-height: var(--line-height-base, 1.4);\n}\n\nhtml[data-layout='mobile'] .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile-edit-dialog__image-preview-actions {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: var(--spacing-xxs, 0.3125rem);\n  width: 100%;\n  align-items: stretch;\n}\n\nhtml[data-layout='mobile'] .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile-edit-dialog__image-button {\n  width: 100%;\n  min-width: 0;\n}\n\nhtml[data-layout='mobile'] .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile-edit-dialog__image-button::part(button) {\n  min-width: 0;\n  width: 100%;\n  justify-content: center;\n  padding: var(--spacing-xxs, 0.3125rem) var(--spacing-2xs, 0.625rem);\n  font-size: var(--profile-edit-dialog-mobile-image-button-font-size);\n}\n\nhtml[data-layout='mobile'] .profile-edit-dialog__row--address-header .profile-edit-dialog__actions {\n  justify-content: flex-end;\n}\n\n@media (max-width: 576px) {\n  .profile-edit-dialog__row {\n    max-width: 100%;\n    flex-direction: column;\n    align-items: stretch;\n  }\n  .profile__edit-form {\n    --profile-edit-dialog-mobile-image-button-font-size: var(--font-size-md, 1rem);\n    --profile-edit-dialog-mobile-image-label-font-size: var(--font-size-sm, 0.875rem);\n    --profile-edit-dialog-mobile-image-description-font-size: 0.625rem;\n  }\n\n  .profile-edit-dialog__section-heading {\n    font-size: var(--font-size-lg, 1.125rem);\n    line-height: var(--line-height-tight, 1.4);\n  }\n\n  #profile-modal .modal .profile__section-header:not(.profile-edit-dialog__contact-section-header) {\n    padding: var(--spacing-sm, 0.938rem);\n    gap: var(--spacing-lg, 1.5625rem);\n  }\n\n  #profile-modal .modal .profile__section-header .profile-edit-dialog__section-heading {\n    font-size: var(--font-size-lg, 1.125rem);\n    line-height: var(--line-height-tight, 1.4);\n  }\n\n  #profile-modal .modal .profile__section-header .profile__action-button,\n  #profile-modal .modal .profile__section-header solid-ui-button.profile__action-button::part(button) {\n    font-size: var(--font-size-sm, 0.875rem);\n    line-height: var(--line-height-base, 1.5);\n  }\n\n  #profile-modal .modal .profile__section-header .profile__add-more-content,\n  #profile-modal .modal .profile__section-header .profile-section-collapsible__edit-label {\n    font-size: var(--font-size-sm, 0.875rem);\n  }\n\n  #profile-modal .modal .profile__section-header .profile__add-more-icon,\n  #profile-modal .modal .profile__section-header .profile-section-collapsible__edit-icon {\n    width: var(--icon-xxs, 1rem);\n    height: var(--icon-xxs, 1rem);\n    padding: 0.125rem;\n    box-sizing: border-box;\n  }\n\n  #profile-modal .modal .profile__section-header .profile__add-more-icon svg,\n  #profile-modal .modal .profile__section-header .profile-section-collapsible__edit-icon svg {\n    width: 100%;\n    height: 100%;\n  }\n\n  .profile-edit-dialog__row--equal > .profile-edit-dialog__field,\n  .profile-edit-dialog__row--equal > .profile-edit-dialog__field-type {\n    flex: 1 1 auto;\n  }\n\n  .profile-edit-dialog__field-type {\n    flex: 1 1 auto;\n  }\n\n  .profile-edit-dialog__row--inline-end {\n    justify-content: flex-start;\n  }\n\n  .profile-edit-dialog__actions {\n    justify-content: flex-start;\n  }\n\n  .profile-edit-dialog__textarea {\n    min-height: 15rem !important;\n  }\n\n  .profile-edit-dialog__input--with-action {\n    padding-right: 6.5rem;\n  }\n\n  .profile-edit-dialog__paste-button {\n    right: var(--spacing-xxs, 0.3125rem);\n    --button-padding-md: var(--spacing-xxs, 0.3125rem) var(--spacing-xxs, 0.3125rem);\n    --button-font-size-md: var(--font-size-2xs, 0.6875rem);\n    --button-icon-size-md: var(--font-size-xxs, 0.75rem);\n    --button-icon-size-lg: var(--font-size-xxs, 0.75rem);\n  }\n\n  .profile-edit-dialog__field input,\n  .profile-edit-dialog__field select,\n  .profile-edit-dialog__field-type input,\n  .profile-edit-dialog__field-type select,\n  .profile-edit-dialog__textarea {\n    font-size: var(--font-size-sm, 0.875rem);\n  }\n\n  #profile-modal .modal .profile-edit-dialog__field solid-ui-select,\n  #profile-modal .modal .profile-edit-dialog__field solid-ui-combobox,\n  #profile-modal .modal .profile-edit-dialog__field-type solid-ui-select,\n  #profile-modal .modal .profile-edit-dialog__field-type solid-ui-combobox {\n    --font-size-sm: var(--font-size-sm, 0.875rem);\n  }\n\n  #profile-modal .modal solid-ui-combobox::part(input),\n  #profile-modal .modal solid-ui-combobox::part(option),\n  #profile-modal .modal solid-ui-combobox::part(selected-option),\n  #profile-modal .modal solid-ui-select::part(select-trigger),\n  #profile-modal .modal solid-ui-select::part(trigger-label),\n  #profile-modal .modal solid-ui-select::part(option),\n  #profile-modal .modal solid-ui-select::part(selected-option) {\n    font-size: var(--font-size-sm, 0.875rem);\n  }\n\n  .profile-edit-dialog__input-help-text {\n    display: none;\n  }\n\n  .profile-edit-dialog__field-type--contact-point {\n    flex: 1 1 auto;\n    width: 100%;\n    max-width: 100%;\n  }\n\n  .profile-edit-dialog--heading .profile-edit-dialog__row--contact-point {\n    flex-direction: row;\n    align-items: stretch;\n  }\n\n  .profile-edit-dialog--heading .profile-edit-dialog__row--contact-point.profile-edit-dialog__row--equal > .profile-edit-dialog__field-type.profile-edit-dialog__field-type--contact-point {\n    flex: 0 0 6.4375rem;\n    width: 6.4375rem;\n    min-width: 6.4375rem;\n    max-width: 6.4375rem;\n  }\n\n  .profile-edit-dialog__row--address-header {\n    flex-direction: row;\n    align-items: flex-end;\n  }\n\n  .profile-edit-dialog__row--social {\n    margin-left: 0;\n    gap: var(--spacing-2xs, 0.625rem);\n    flex-direction: row;\n    align-items: center;\n    flex-wrap: nowrap;\n  }\n\n  .profile-edit-dialog__row--social .profile-edit-dialog__social-icon {\n    display: none;\n  }\n\n  .profile-edit-dialog__field--social-type {\n    flex: 0 0 4.75rem;\n    width: 4.75rem;\n    max-width: 4.75rem;\n  }\n\n  .profile-edit-dialog__field--social-url {\n    flex: 1 1 auto;\n    min-width: 0;\n  }\n\n  .profile-edit-dialog__field--resume-location {\n    flex: 1 1 100%;\n    width: 100%;\n    max-width: 100%;\n  }\n\n  .profile-edit-dialog__row--language {\n    flex-direction: row;\n    align-items: center;\n    flex-wrap: nowrap;\n    gap: var(--spacing-xxs, 0.3125rem);\n    margin-left: calc(-1 * var(--spacing-xxs, 0.3125rem));\n  }\n\n  .profile-edit-dialog__row--language > .profile-edit-dialog__field--language-name {\n    flex: 1 1 0;\n    min-width: 0;\n    margin-left: calc(-1 * var(--spacing-xxs, 0.3125rem));\n  }\n\n  .profile-edit-dialog__actions--language {\n    margin-left: 0;\n  }\n\n  .profile-edit-dialog__row--language > solid-ui-button.profile-edit-dialog__drag-handle,\n  .profile-edit-dialog__actions--language > solid-ui-button.profile-edit-dialog__delete-button {\n    min-width: var(--min-touch-target, 44px);\n    min-height: var(--min-touch-target, 44px);\n    --button-height-md: var(--min-touch-target, 44px);\n  }\n\n  .profile-edit-dialog__row--resume-entry-header {\n    flex-direction: row;\n    align-items: center;\n    flex-wrap: nowrap;\n    width: 100%;\n    max-width: 100%;\n  }\n\n  .profile-edit-dialog__row--resume-entry-header > .profile-edit-dialog__actions--edge {\n    margin-left: auto;\n  }\n\n  .profile-edit-dialog__row--skill {\n    flex-direction: row;\n    align-items: center;\n    flex-wrap: nowrap;\n    gap: var(--spacing-2xs, 0.625rem);\n  }\n\n  .profile-edit-dialog__row--skill > .profile-edit-dialog__field {\n    flex: 1 1 0;\n    min-width: 0;\n  }\n\n  .profile-edit-dialog__row--skill > .profile-edit-dialog__actions {\n    flex: 0 0 auto;\n    margin-left: 0;\n  }\n\n  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo {\n    flex-direction: row;\n    align-items: center;\n    flex-wrap: nowrap;\n    gap: var(--spacing-xs, 0.75rem);\n    width: 100%;\n    max-width: 100%;\n  }\n\n  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo > header {\n    margin-bottom: 0;\n    flex: 0 0 auto;\n  }\n\n  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile__hero,\n  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile__hero-alt {\n    width: 5rem;\n    height: 5rem;\n  }\n\n  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile__hero-alt {\n    padding: 0;\n  }\n\n  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile__image-frame--fallback .profile__hero-alt {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile-edit-dialog__image-camera-button {\n    display: inline-flex;\n    right: var(--spacing-xxs, 0.3125rem);\n    bottom: var(--spacing-xxs, 0.3125rem);\n    width: var(--min-touch-target, 44px);\n    height: var(--min-touch-target, 44px);\n    min-width: var(--min-touch-target, 44px);\n    min-height: var(--min-touch-target, 44px);\n    --button-height-md: var(--min-touch-target, 44px);\n  }\n\n  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile-edit-dialog__image-preview {\n    flex: 1 1 auto;\n    min-width: 0;\n    gap: var(--spacing-xxs, 0.3125rem);\n    width: 100%;\n  }\n\n  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile-edit-dialog__image-preview-label {\n    font-size: var(--profile-edit-dialog-mobile-image-label-font-size);\n    line-height: var(--line-height-tight, 1.25);\n  }\n\n  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile-edit-dialog__image-preview-description {\n    font-size: var(--profile-edit-dialog-mobile-image-description-font-size);\n    line-height: var(--line-height-base, 1.4);\n  }\n\n  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile-edit-dialog__image-preview-actions {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: var(--spacing-xs, 0.5rem);\n    width: 100%;\n    align-items: stretch;\n  }\n\n  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile-edit-dialog__image-button {\n    width: 100%;\n    min-width: 0;\n  }\n\n  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile-edit-dialog__image-button::part(button) {\n    min-width: 0;\n    width: 100%;\n    justify-content: center;\n    padding: var(--spacing-xxs, 0.3125rem) var(--spacing-2xs, 0.625rem);\n    font-size: var(--profile-edit-dialog-mobile-image-button-font-size);\n  }\n\n  .profile-edit-dialog__row--address-header .profile-edit-dialog__actions {\n    justify-content: flex-end;\n  }\n}\n\n@container profile-pane (max-width: 576px) {\n  .profile-edit-dialog__row {\n    max-width: 100%;\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .profile__edit-form {\n    --profile-edit-dialog-mobile-image-button-font-size: var(--font-size-md, 1rem);\n    --profile-edit-dialog-mobile-image-label-font-size: var(--font-size-sm, 0.875rem);\n    --profile-edit-dialog-mobile-image-description-font-size: 0.625rem;\n  }\n\n  .profile-edit-dialog__section-heading {\n    font-size: var(--font-size-lg, 1.125rem);\n    line-height: var(--line-height-tight, 1.4);\n  }\n\n  #profile-modal .modal .profile__section-header:not(.profile-edit-dialog__contact-section-header) {\n    padding: var(--spacing-sm, 0.938rem);\n    gap: var(--spacing-lg, 1.5625rem);\n  }\n\n  #profile-modal .modal .profile__section-header .profile-edit-dialog__section-heading {\n    font-size: var(--font-size-lg, 1.125rem);\n    line-height: var(--line-height-tight, 1.4);\n  }\n\n  #profile-modal .modal .profile__section-header .profile__action-button,\n  #profile-modal .modal .profile__section-header solid-ui-button.profile__action-button::part(button) {\n    font-size: var(--font-size-sm, 0.875rem);\n    line-height: var(--line-height-base, 1.5);\n  }\n\n  #profile-modal .modal .profile__section-header .profile__add-more-content,\n  #profile-modal .modal .profile__section-header .profile-section-collapsible__edit-label {\n    font-size: var(--font-size-sm, 0.875rem);\n  }\n\n  #profile-modal .modal .profile__section-header .profile__add-more-icon,\n  #profile-modal .modal .profile__section-header .profile-section-collapsible__edit-icon {\n    width: var(--icon-xxs, 1rem);\n    height: var(--icon-xxs, 1rem);\n    padding: 0.125rem;\n    box-sizing: border-box;\n  }\n\n  #profile-modal .modal .profile__section-header .profile__add-more-icon svg,\n  #profile-modal .modal .profile__section-header .profile-section-collapsible__edit-icon svg {\n    width: 100%;\n    height: 100%;\n  }\n\n  .profile-edit-dialog__row--equal > .profile-edit-dialog__field,\n  .profile-edit-dialog__row--equal > .profile-edit-dialog__field-type {\n    flex: 1 1 auto;\n  }\n\n  .profile-edit-dialog__field-type {\n    flex: 1 1 auto;\n  }\n\n  .profile-edit-dialog__row--inline-end {\n    justify-content: flex-start;\n  }\n\n  .profile-edit-dialog__actions {\n    justify-content: flex-start;\n  }\n\n  .profile-edit-dialog__textarea {\n    min-height: 15rem !important;\n  }\n\n  .profile-edit-dialog__input--with-action {\n    padding-right: 6.5rem;\n  }\n\n  .profile-edit-dialog__paste-button {\n    right: var(--spacing-xxs, 0.3125rem);\n    --button-padding-md: var(--spacing-xxs, 0.3125rem) var(--spacing-xxs, 0.3125rem);\n    --button-font-size-md: var(--font-size-2xs, 0.6875rem);\n    --button-icon-size-md: var(--font-size-xxs, 0.75rem);\n    --button-icon-size-lg: var(--font-size-xxs, 0.75rem);\n  }\n\n  .profile-edit-dialog__field input,\n  .profile-edit-dialog__field select,\n  .profile-edit-dialog__field-type input,\n  .profile-edit-dialog__field-type select,\n  .profile-edit-dialog__textarea {\n    font-size: var(--font-size-sm, 0.875rem);\n  }\n\n  #profile-modal .modal .profile-edit-dialog__field solid-ui-select,\n  #profile-modal .modal .profile-edit-dialog__field solid-ui-combobox,\n  #profile-modal .modal .profile-edit-dialog__field-type solid-ui-select,\n  #profile-modal .modal .profile-edit-dialog__field-type solid-ui-combobox {\n    --font-size-sm: var(--font-size-sm, 0.875rem);\n  }\n\n  #profile-modal .modal solid-ui-combobox::part(input),\n  #profile-modal .modal solid-ui-combobox::part(option),\n  #profile-modal .modal solid-ui-combobox::part(selected-option),\n  #profile-modal .modal solid-ui-select::part(select-trigger),\n  #profile-modal .modal solid-ui-select::part(trigger-label),\n  #profile-modal .modal solid-ui-select::part(option),\n  #profile-modal .modal solid-ui-select::part(selected-option) {\n    font-size: var(--font-size-sm, 0.875rem);\n  }\n\n  .profile-edit-dialog__input-help-text {\n    display: none;\n  }\n\n  .profile-edit-dialog__field-type--contact-point {\n    flex: 1 1 auto;\n    width: 100%;\n    max-width: 100%;\n  }\n\n  .profile-edit-dialog--heading .profile-edit-dialog__row--contact-point {\n    flex-direction: row;\n    align-items: stretch;\n  }\n\n  .profile-edit-dialog--heading .profile-edit-dialog__row--contact-point.profile-edit-dialog__row--equal > .profile-edit-dialog__field-type.profile-edit-dialog__field-type--contact-point {\n    flex: 0 0 6.4375rem;\n    width: 6.4375rem;\n    min-width: 6.4375rem;\n    max-width: 6.4375rem;\n  }\n\n  .profile-edit-dialog__row--address-header {\n    flex-direction: row;\n    align-items: flex-end;\n  }\n\n  .profile-edit-dialog__row--social {\n    margin-left: 0;\n    gap: var(--spacing-2xs, 0.625rem);\n    flex-direction: row;\n    align-items: center;\n    flex-wrap: nowrap;\n  }\n\n  .profile-edit-dialog__row--social .profile-edit-dialog__social-icon {\n    display: none;\n  }\n\n  .profile-edit-dialog__field--social-type {\n    flex: 0 0 4.75rem;\n    width: 4.75rem;\n    max-width: 4.75rem;\n  }\n\n  .profile-edit-dialog__field--social-url {\n    flex: 1 1 auto;\n    min-width: 0;\n  }\n\n  .profile-edit-dialog__field--resume-location {\n    flex: 1 1 100%;\n    width: 100%;\n    max-width: 100%;\n  }\n\n  .profile-edit-dialog__row--language {\n    flex-direction: row;\n    align-items: center;\n    flex-wrap: nowrap;\n    gap: var(--spacing-xxs, 0.3125rem);\n    margin-left: calc(-1 * var(--spacing-xxs, 0.3125rem));\n  }\n\n  .profile-edit-dialog__row--language > .profile-edit-dialog__field--language-name {\n    flex: 1 1 0;\n    min-width: 0;\n    margin-left: calc(-1 * var(--spacing-xxs, 0.3125rem));\n  }\n\n  .profile-edit-dialog__actions--language {\n    margin-left: 0;\n  }\n\n  .profile-edit-dialog__row--language > solid-ui-button.profile-edit-dialog__drag-handle,\n  .profile-edit-dialog__actions--language > solid-ui-button.profile-edit-dialog__delete-button {\n    min-width: var(--min-touch-target, 44px);\n    min-height: var(--min-touch-target, 44px);\n    --button-height-md: var(--min-touch-target, 44px);\n  }\n\n  .profile-edit-dialog__row--resume-entry-header {\n    flex-direction: row;\n    align-items: center;\n    flex-wrap: nowrap;\n    width: 100%;\n    max-width: 100%;\n  }\n\n  .profile-edit-dialog__row--resume-entry-header > .profile-edit-dialog__actions--edge {\n    margin-left: auto;\n  }\n\n  .profile-edit-dialog__row--skill {\n    flex-direction: row;\n    align-items: center;\n    flex-wrap: nowrap;\n    gap: var(--spacing-2xs, 0.625rem);\n  }\n\n  .profile-edit-dialog__row--skill > .profile-edit-dialog__field {\n    flex: 1 1 0;\n    min-width: 0;\n  }\n\n  .profile-edit-dialog__row--skill > .profile-edit-dialog__actions {\n    flex: 0 0 auto;\n    margin-left: 0;\n  }\n\n  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile__hero,\n  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile__hero-alt {\n    width: 5rem;\n    height: 5rem;\n  }\n\n  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo {\n    flex-direction: row;\n    align-items: center;\n    flex-wrap: nowrap;\n    gap: var(--spacing-xs, 0.75rem);\n    width: 100%;\n    max-width: 100%;\n  }\n\n  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo > header {\n    margin-bottom: 0;\n    flex: 0 0 auto;\n  }\n\n  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile__hero-alt {\n    padding: 0;\n  }\n\n  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile__image-frame--fallback .profile__hero-alt {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile-edit-dialog__image-camera-button {\n    display: inline-flex;\n    right: var(--spacing-xxs, 0.3125rem);\n    bottom: var(--spacing-xxs, 0.3125rem);\n    width: var(--min-touch-target, 44px);\n    height: var(--min-touch-target, 44px);\n    min-width: var(--min-touch-target, 44px);\n    min-height: var(--min-touch-target, 44px);\n    --button-height-md: var(--min-touch-target, 44px);\n  }\n\n  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile-edit-dialog__image-preview {\n    flex: 1 1 auto;\n    min-width: 0;\n    gap: var(--spacing-xxs, 0.3125rem);\n    width: 100%;\n  }\n\n  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile-edit-dialog__image-preview-label {\n    font-size: var(--profile-edit-dialog-mobile-image-label-font-size);\n    line-height: var(--line-height-tight, 1.25);\n  }\n\n  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile-edit-dialog__image-preview-description {\n    font-size: var(--profile-edit-dialog-mobile-image-description-font-size);\n    line-height: var(--line-height-base, 1.4);\n  }\n\n  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile-edit-dialog__image-preview-actions {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: var(--spacing-xs, 0.5rem);\n    width: 100%;\n    align-items: stretch;\n  }\n\n  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile-edit-dialog__image-button {\n    width: 100%;\n    min-width: 0;\n  }\n\n  .profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo .profile-edit-dialog__image-button::part(button) {\n    min-width: 0;\n    width: 100%;\n    justify-content: center;\n    padding: var(--spacing-xxs, 0.3125rem) var(--spacing-2xs, 0.625rem);\n    font-size: var(--profile-edit-dialog-mobile-image-button-font-size);\n  }\n\n  .profile-edit-dialog__row--address-header .profile-edit-dialog__actions {\n    justify-content: flex-end;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
